function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.15305 19.6037V36.1912H13.7246V27.1844C13.7246 27.1844 13.7246 22.8955 18.0136 22.8955C22.3025 22.8955 22.3025 27.1844 22.3025 27.1844V36.1912H32.5752V19.6037C26.7959 13.8244 23.5684 10.5969 17.8641 4.89262C12.1598 10.672 8.93239 13.8994 3.15305 19.6037Z",
  fill: "#FFD15C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.3517 16.3623L19.6649 0.67551C18.7642 -0.22517 17.188 -0.22517 16.2873 0.67551L0.67551 16.3623C-0.22517 17.263 -0.22517 18.8392 0.67551 19.7399C1.57619 20.6405 3.15238 20.6405 4.05306 19.7399L18.0136 5.77934L31.9741 19.7399C32.8748 20.6405 34.451 20.6405 35.3517 19.7399C36.2524 18.7642 36.2524 17.263 35.3517 16.3623Z",
  fill: "#E91E63"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.a3f4ab20.svg";
export { ForwardRef as ReactComponent };